import React from "react";
import { Button, Spinner, ProgressBar, Alert } from "react-bootstrap";

const EmbeddingProcessor = ({ 
  processing, 
  progress, 
  statusMessage, 
  error, 
  success, 
  onProcess, 
  disabled 
}) => {
  return (
    <>
      <Button 
        variant="primary" 
        onClick={onProcess} 
        disabled={processing || disabled}
      >
        {processing ? <Spinner animation="border" size="sm" /> : 'Procesar Documento'}
      </Button>

      {processing && (
        <div className="mt-3">
          <ProgressBar now={progress} label={`${progress}%`} />
          <p className="mt-2">{statusMessage}</p>
        </div>
      )}

      {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
      {success && <Alert variant="success" className="mt-3">¡Documento procesado exitosamente!</Alert>}
    </>
  );
};

export default EmbeddingProcessor;